export const DEFAULT_LOCALE = 'en';

export type TDateFormat =
  | 'APP_DATE_FORMAT'
  | 'APP_LOCAL_DATE_FORMAT'
  | 'APP_DATE_FORMAT_WITHOUT_HOURS'
  | 'APP_LOCAL_DATE_FORMAT_EXTENDED'
  | 'APP_LOCAL_DATETIME_FORMAT'
  | 'APP_LOCAL_DATETIME_FORMAT_Z'
  | 'APP_WHOLE_NUMBER_FORMAT'
  | 'APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT'
  | 'DATETIME';

export type TDateFormats = {
  [key in TDateFormat]: string;
};

export const DATE_FORMATS: TDateFormats = {
  APP_DATE_FORMAT: 'DD/MM/YY HH:mm',
  APP_LOCAL_DATE_FORMAT: 'DD MMM YYYY',
  APP_DATE_FORMAT_WITHOUT_HOURS: 'DD/MM/YYYY',
  APP_LOCAL_DATE_FORMAT_EXTENDED: 'DD MMMM YYYY',
  APP_LOCAL_DATETIME_FORMAT: 'YYYY-MM-DDTHH:mm',
  APP_LOCAL_DATETIME_FORMAT_Z: 'YYYY-MM-DDTHH:mm Z',
  APP_WHOLE_NUMBER_FORMAT: '0,0',
  APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT: '0,0.[00]',
  DATETIME: 'DD MMM YYYY HH:mm',
};

export const JWT_TOKEN = 'jwt_token';

export const SYSTEM_ROLE = 'System';

export const STARTING_YEAR = 2020;

export const WEBSITE_URL = 'https://www.adamantic.io/';
export const FACEBOOK_URL = 'https://www.facebook.com/adamantic.io';
export const LINKEDIN_URL = 'https://it.linkedin.com/company/adamantic';
export const YOUTUBE_URL = 'https://www.youtube.com/channel/UCYsHg4e1Qsks-cxWkasqTAg';
export const AVATAR_IMAGE_FALLBACK = '/images/avatar.png';
